import React, { useEffect, useCallback } from 'react';

import classNames from 'classnames';

import classes from './styles.module.scss';

export default function Tabs({
  tabs,
  currentTab,
  setCurrentTab,
  countData,
  name,
}) {
  const isObjectTabs = Array.isArray(tabs) && typeof tabs[0] === 'object';
  const normalizedTabs = (tabs || []).map((tab) =>
    isObjectTabs ? { id: tab.id, label: tab.label } : { id: tab, label: tab }
  );

  const isIdMode = isObjectTabs;

  const saveTabChoice = (value) => {
    localStorage.setItem(`tab${name}`, value);
  };

  const restoreTab = useCallback(() => {
    const stored = localStorage.getItem(`tab${name}`);
    if (!stored) {
      return;
    }

    if (isIdMode) {
      const foundById = normalizedTabs.find((t) => t.id === stored);
      if (foundById) {
        setCurrentTab(foundById.id);
        return;
      }
      const foundByLabel = normalizedTabs.find((t) => t.label === stored);
      if (foundByLabel) {
        setCurrentTab(foundByLabel.id);
      }
    } else {
      setCurrentTab(stored);
    }
  }, [isIdMode, name, normalizedTabs, setCurrentTab]);

  const switchTab = (tab) => {
    const valueToSet = isIdMode ? tab.id : tab.label;
    setCurrentTab(valueToSet);
    saveTabChoice(valueToSet);
  };

  useEffect(() => {
    restoreTab();
  }, [restoreTab]);

  return (
    <div className={classes.Tabs}>
      {normalizedTabs.map((tab) => (
        <div
          onKeyPress={(event) => {
            if (event.key === 'Enter') {
              switchTab(tab);
            }
          }}
          onClick={() => switchTab(tab)}
          className={classNames(classes.tab, {
            [classes.active]:
              (isIdMode &&
                (currentTab === tab.id || currentTab === tab.label)) ||
              (!isIdMode && currentTab === tab.label),
          })}
          key={tab.id}
          tabIndex={0}
          role="button"
        >
          <span>{tab.label}</span>
          <div className={classes.count}>
            {countData?.[tab.id] ?? countData?.[tab.label]}
          </div>
        </div>
      ))}
    </div>
  );
}
